import React, { useState } from 'react';
import styled from 'styled-components';

import useResourceHubComponentCollections from '../../hooks/useResourceHubComponentCollections';
import ImageCardSliderSection from '../Sections/ImageCardSections/ImageCardSliderSection';
import CustomerResourceHubFilters from './CustomerResourceHubFilters';

const CustomerResourceHub = () => {
  const [values, setValues] = useState({
    focus: null,
    personas: null,
    products: null,
  });

  const allCollections = useResourceHubComponentCollections();

  const getTitle = (id) =>
    allCollections?.find((collection) => collection.templateId === id)?.templateName;

  const getCards = (id, excludeFilter) => {
    const componentCollection = allCollections?.find((collection) => collection.templateId === id);
    const allCards = componentCollection?.components;

    const filteredCards = allCards.filter((card) => {
      const { taxonomy } = card;

      const includesFocus = () => {
        let focuses;

        if (taxonomy.businessFocusJobType) {
          focuses = taxonomy.businessFocusJobType;
        } else {
          const types = taxonomy.jobType.map((type) => type.replace('Service & Repair', 'S/R'));
          focuses = types.map((type) => taxonomy.businessFocus.map((focus) => `${focus} ${type}`));
        }

        return focuses?.flat()?.includes(values.focus);
      };

      const filters = {
        focus: !values.focus || values.focus === 'All Business Focuses' || includesFocus(),
        personas:
          !values.personas ||
          values.personas === 'All Personas' ||
          taxonomy.personas?.includes(values.personas),
        products:
          !values.products ||
          values.products === 'All Products' ||
          values.products !== 'Pro Products' ||
          taxonomy.topics?.includes('Pro Features'),
      };

      if (filters.focus && filters.personas && filters.products) {
        return card;
      }
    });

    return excludeFilter ? allCards : filteredCards;
  };

  const collections = [
    'Platform',
    'Videos',
    'Programs & Groups',
    'Subscriptions',
    'Events',
    'Pro Products',
    'Pro Workshops',
  ];

  return (
    <Container className="pt-14">
      <div className="pb-10">
        <ImageCardSliderSection
          title="Featured Resources"
          sectionsData={getCards('Featured Resources', true)}
          titleColor="var(--darkest)"
          showExcerpt
        />
      </div>
      <div className="bg-neutral-50 py-14">
        <CustomerResourceHubFilters setValues={setValues} values={values} />
        {collections.map((collection) => {
          const cards = getCards(collection);
          const title = getTitle(collection);
          const formattedCards = cards.map((card) => {
            const { level } = card.taxonomy;
            return { ...card, taxonomy: { ...card.taxonomy, level: !level ? ' ' : level } };
          });

          return cards.length > 0 ? (
            <ImageCardSliderSection
              title={title}
              sectionsData={formattedCards}
              titleColor="var(--darkest)"
              showExcerpt
            />
          ) : null;
        })}
      </div>
    </Container>
  );
};

export default CustomerResourceHub;

const Container = styled.div`
  .slider-arrow--left-side {
    left: -107px !important;
    background: linear-gradient(
      270deg,
      rgba(255, 255, 255, 1) 20%,
      rgba(255, 255, 255, 0) 100%
    ) !important;
  }

  .slider-arrow--right-side {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 1) 70%
    ) !important;
  }

  .slider-title {
    margin-bottom: 5px;
  }

  .card-slider-section:first-child {
    padding-bottom: 15px;
  }

  @media (max-width: 987px) and (min-width: 576px) {
    .top-info {
      padding: 0 36px;
    }
  }

  @media (min-width: 768px) {
    .card-slider-section {
      padding-bottom: 30px;
    }
  }

  @media (min-width: 1296px) {
    .card-slider-section {
      padding-bottom: 50px;
    }
  }
`;
